export default "__VITE_ASSET__fP08Si5U__"